import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
  selector: 'app-madison-thankyou',
  templateUrl: './madison-thankyou.component.html',
  styleUrls: ['./madison-thankyou.component.css']
})
export class MadisonThankyouComponent implements OnInit {

  constructor(private _router: Router) { }

  ngOnInit(): void {

    localStorage.clear();
  }

  finishClicked(){

    this._router.navigateByUrl('/madison');

    }

}
